import { useApi } from '@/hooks/use_api';
import { UseActionExecuteType } from '@/models/action_base';

import { useRouting } from './use_routing';

async function isFirstEntry() {
  const api = useApi();
  const response = await api.getUsers();
  return !!response.dataJson.isFirstEntry;
}

/**
 * プログラム内容で評価した is_first_entry を見て、応募したことがあると判断すれば内部遷移する
 *
 * オプション: 遷移先の URL
 */

export function useActionRedirectIfEntried(router: ReturnType<typeof useRouting>, path?: string): UseActionExecuteType {
  return async () => {
    if (!(await isFirstEntry()) && !!path) {
      await router.redirect(path);
      return true;
    }
    return false;
  };
}

/**
 * プログラム内容で評価した is_first_entry を見て、まだ応募したことがないと判断すれば内部遷移する
 *
 * オプション: 遷移先の URL
 */

export function useActionRedirectIfNotEntried(router: ReturnType<typeof useRouting>, path?: string): UseActionExecuteType {
  return async () => {
    if (await isFirstEntry() && !!path) {
      await router.redirect(path);
      return true;
    }
    return false;
  };
}
